"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethodToggle = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _googlePayMark = _interopRequireDefault(require("../../../assets/boost/google-pay-mark.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// boost-checkout/components/PaymentMethodToggle.tsx

var PaymentMethodToggle = exports.PaymentMethodToggle = function PaymentMethodToggle(_ref) {
  var paymentMethod = _ref.paymentMethod,
    setPaymentMethod = _ref.setPaymentMethod,
    isApplePayEligible = _ref.isApplePayEligible,
    isGooglePayEligible = _ref.isGooglePayEligible;
  // Only show if Apple Pay is eligible
  if (!isApplePayEligible && !isGooglePayEligible) return null;
  return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
    component: "legend"
  }, "Payment Method"), /*#__PURE__*/_react["default"].createElement(_material.RadioGroup, {
    row: true,
    "aria-label": "payment-method",
    name: "payment-method-group",
    className: "flex",
    value: paymentMethod,
    onChange: function onChange(e) {
      return setPaymentMethod(e.target.value);
    }
  }, isApplePayEligible && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "apple_pay",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-medium"
    }, "Apple Pay"), /*#__PURE__*/_react["default"].createElement("i", {
      className: "fa-brands fa-apple-pay",
      style: {
        fontSize: 28
      }
    }))
  }), isGooglePayEligible && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "google_pay",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center gap-2 py-1"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-medium"
    }, "Google Pay"), /*#__PURE__*/_react["default"].createElement("img", {
      alt: "",
      src: _googlePayMark["default"],
      style: {
        maxHeight: 24,
        width: "auto"
      }
    }))
  }), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "card",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-medium"
    }, "Pay with Card"), /*#__PURE__*/_react["default"].createElement("i", {
      className: "text-lg fa-solid fa-credit-card"
    }))
  })));
};